module.exports = __webpack_public_path__ + "static/default.edce5549.png";